import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EmailFormArray } from './email-form-array';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';

import { InputTextComponent } from '../../../../../../components/form/input-text.component';

@Component({
  selector: 'protocol-email-input',
  templateUrl: './protocol-email-input.component.html',
  imports: [
    ZenithComponentsModule,
    TranslateModule,
    ReactiveFormsModule,
    InputTextComponent
  ],
  standalone: true
})
export class ProtocolEmailInputComponent implements OnInit {
  @Input() emailFormArray: EmailFormArray;
  @Input() disabled: boolean;
  @Input() labelKey: string;

  ngOnInit(): void {
    if (this.emailFormArray.length === 0) {
      this.addEmailAddressControl();
    }
  }

  addEmailAddressControl() {
    this.emailFormArray.addEmailFormControl();
  }

  removeEmailAddressControl(index: number) {
    this.emailFormArray.removeAt(index);
  }
}
